import Modal from '../node_modules/modal-js/dist/modal';
import notification from 'notification-js';
import Spinner from 'spin';
import Config from 'config';
import * as Validation from './Validation';
import AuthDataStorage from "./AuthDataStorage";

export default class Register {
  constructor() {
    this.authDataStorage = new AuthDataStorage();
    this.getQueryParams();
    this.formSubmit();

    this.licenceInfoElement = document.getElementsByClassName('licence-info')[0];
    this.getLicenceInfo();
  }

  getQueryParams() {
    let queryStrings = window.location.search.substr(1).split("&");

    queryStrings.forEach((queryString) => {
      if (queryString.indexOf("id=") === 0) {
        this.licenceId = queryString.substr(3);
      }
    });

    if (!this.licenceId) {
      window.location = "/buy-now.html";
    }
  }

  getOptionLabel(key) {
    switch(key) {
      case 'user': return 'Users';
      case 'project': return 'Projects';
      case 'teams': return 'Teams';
      case 'displays': return 'Displays';
      case 'library': return 'GB';
      default : return;
    }
  }

  getOptionKey(key) {
    switch(key) {
      case 'user': return 'numberOfUsers';
      case 'project': return 'numberOfProjects';
      case 'teams': return 'numberOfTeams';
      case 'displays': return 'numberOfDisplays';
      case 'library': return 'storage';
      default : return;
    }
  }

  getLicenceInfo() {
    let data = {
      file: './data/buy-now.json'
    };

    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let licenceInfo = JSON.parse(xobj.response);
        let licences = licenceInfo.sections[0].prices; // get licence for marketing name

        for (var i =0; i< licences.length; i++) {
          if (parseInt(licences[i].licenceId) == parseInt(this.licenceId)) {
            this.licence = licences[i];
            break;
          }
        }

        if (this.licence) {
          this.formSubmit();
          this.setupLicenceInfo();
          this.overlay = document.getElementsByClassName('overlay')[0];
          this.spinner = new Spinner({
            color:'#fff',
            lines: 12,
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            position: 'absolute' // Element positioning
          }).spin(this.overlay);
        } else {
          window.location = "/buy-now.html";
        }
      }
    }.bind(this);
    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xobj.send(JSON.stringify(data));
  }

  setupLicenceInfo() {
    this.licenceInfoElement.getElementsByClassName('name')[0].innerHTML = this.licence.name;

    var dynamic = localStorage.getItem(this.licenceId + "-dynamic");
    if (dynamic) {
      dynamic = JSON.parse(dynamic);
    }

    let dynamicProperties = "";
    for (var key in dynamic) {
      dynamicProperties += dynamic[key][this.getOptionKey(key)] + " " + this.getOptionLabel(key) + "<br>";
    }

    this.licenceInfoElement.getElementsByClassName('dynamic')[0].innerHTML = dynamicProperties;

    let addonsProperties = localStorage.getItem(this.licenceId + "-addons");
    if (addonsProperties) {
      addonsProperties = JSON.parse(addonsProperties)
    }
    console.log(addonsProperties);
    var addonsPropertiesHtml = "";
    for (let licenseId in addonsProperties) {
      if (addonsProperties.hasOwnProperty(licenseId)) {
        if (parseInt(addonsProperties[licenseId].count) > 0)
          addonsPropertiesHtml += addonsProperties[licenseId].name + " x" + addonsProperties[licenseId].count + "<br>";
      }
    }
    this.licenceInfoElement.getElementsByClassName('register-addons-items')[0].innerHTML = addonsPropertiesHtml;
  }

  formSubmit() {
    let form = document.getElementsByClassName('register-form')[0];

    form.onsubmit = function (event) {
      event.preventDefault();

      if (Validation.validateRegisterForm(form)) {
        let username = form.getElementsByClassName('loginUsername')[0];
        let password = form.getElementsByClassName('loginPassword')[0];
        let confirmPassword = form.getElementsByClassName('confirmPassword')[0];
        let groupName = form.getElementsByClassName('companyName')[0];
        let email = form.getElementsByClassName('email')[0];
        let firstname = form.getElementsByClassName('firstname')[0];
        let surname = form.getElementsByClassName('surname')[0];

        let licenceId = this.licenceId;
        let dynamicProperties = localStorage.getItem(this.licenceId + "-dynamic");
        let addonsProperties = localStorage.getItem(this.licenceId + "-addons");

        let paymentTerm = "monthly";
        let isActive = true;

        var request = new XMLHttpRequest();

        request.onreadystatechange = function() {
          if (request.readyState == 4) {
            if (request.status !== 200) {
              return this.registrationError('Their was an error registering please try again.');
            }

            var response = JSON.parse(request.responseText);
            if (!response.success) {
              return this.registrationError(response.error);
            }

            this.setUserAsLoggedIn(response);
            let trialPeriod = parseInt(localStorage.getItem(this.licenceId + "-trial"));

            if (trialPeriod > 0 || parseInt(response.userData.licenceAmount) + parseFloat(response.userData.packageAddonsAmount) == 0) {
              window.location = "/account.html";
            } else {
              window.location = "/payment.html";
            }

          }
        }.bind(this);

        var data = {
          userData: {
            username: username.value,
            password: password.value,
            groupName: groupName.value,
            email: email.value,
            firstname: firstname.value,
            surname: surname.value,
            licenceId,
            dynamic: dynamicProperties,
            addons: addonsProperties,
            paymentTerm,
            isActive
          }
        }

        request.open("POST", Config.BACKEND_URL + '/registerUser');
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        request.send(JSON.stringify(data));
      }

      return false;
    }.bind(this)
  }

  registrationError(message) {
    notification.notify( 'error', message, {
      notification: {position: [ 'right', 'top' ]}
    });
  }

  setUserAsLoggedIn(response) {
    this.authDataStorage.setItem("userData", JSON.stringify(response.userData));
    this.authDataStorage.setItem("groupData", JSON.stringify(response.groupData));
    this.authDataStorage.setItem("loggedIn", true);
    this.authDataStorage.setItem("Auth-Token", true);
  }
}



// WEBPACK FOOTER //
// ./src/Register.js